import React, { Component } from "react";
import { connect } from "react-redux";
import userActions from "../../_actions/userActions";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import AlertModal from "../_common/AlertModal";

class LoginModal extends Component {
  state = {
    loginFormData: {
      username: "",
      password: "",
    },
    loginFormSubmitted: false,
    showAlert_loginFail: false,
    errorOnSubmit: null,
  };

  handleChange_loginForm = (e) => {
    const { name, value } = e.target;
    const loginFormData = { ...this.state.loginFormData };
    loginFormData[name] = value;
    if (name === "username") loginFormData.username = value.toLowerCase();
    this.setState({ loginFormData });
  };

  handleAlert_loginFail = (actionType) => (e) => {
    e && e.preventDefault();
    this.toggleAlert_loginFail();
  };

  toggleAlert_loginFail = () => {
    this.setState({ showAlert_loginFail: !this.state.showAlert_loginFail });
  };

  handleSubmit_loginForm = async (e) => {
    e.preventDefault();
    this.setState({ loginFormSubmitted: true });
    const { loginFormData } = this.state;
    const { dispatch, toggleLoginModal, onSuccess } = this.props;
    if (loginFormData.username && loginFormData.password) {
      try {
        await dispatch(userActions.login(loginFormData.username, loginFormData.password));
        onSuccess && onSuccess();
        toggleLoginModal();
      } catch (err) {
        this.toggleAlert_loginFail();
      }

      this.setState({
        loginFormData: { username: "", password: "" },
        loginFormSubmitted: false,
      });
    }
  };

  render() {
    const { showLoginModal, toggleLoginModal, loggingIn } = this.props;
    const { loginFormData, loginFormSubmitted, showAlert_loginFail, errorOnSubmit } =
      this.state;
    return (
      <React.Fragment>
        <Modal
          isOpen={showLoginModal}
          toggle={toggleLoginModal}
          className={this.props.className}
          fade={false}
          size={"md"}
        >
          <ModalHeader toggle={toggleLoginModal} className="bg-lightgray">
            Log In
          </ModalHeader>
          <ModalBody>
            <form name="loginForm">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div
                      className={
                        "form-group col-12" +
                        (loginFormSubmitted && !loginFormData.username
                          ? " has-error"
                          : "")
                      }
                    >
                      <label htmlFor="username">
                        <b>Username:</b>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="username"
                        id="username"
                        value={loginFormData.username}
                        onChange={this.handleChange_loginForm}
                        disabled={loggingIn}
                      />
                      {loginFormSubmitted && !loginFormData.username && (
                        <span className="error-small">
                          <small>Username is required</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className={
                        "form-group col-12" +
                        (loginFormSubmitted && !loginFormData.password
                          ? " has-error"
                          : "")
                      }
                    >
                      <label htmlFor="password">
                        <b>Password:</b>
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        value={loginFormData.password}
                        onChange={this.handleChange_loginForm}
                        onKeyDown={(e) =>
                          e.key === "Enter" && this.handleSubmit_loginForm(e)
                        }
                        disabled={loggingIn}
                      />
                      {loginFormSubmitted && !loginFormData.password && (
                        <span className="error-small">
                          <small>Password is required</small>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-row form-group mb-0">
              {loggingIn && (
                <span className="mr-3 my-auto">
                  <small>Loggin in...</small>
                </span>
              )}
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.handleSubmit_loginForm}
                disabled={loggingIn}
              >
                Log In
              </button>
              <button
                type="button"
                className="btn btn-secondary ml-2"
                onClick={toggleLoginModal}
              >
                Close
              </button>
            </div>
          </ModalFooter>
        </Modal>
        <AlertModal
          alertTitle={"Login Failed"}
          alertText={`${errorOnSubmit}\nPlease try again.`}
          acceptCaption={"OK"}
          acceptClass={"secondary"}
          provideReject={false}
          handleAlertAction={this.handleAlert_loginFail}
          toggleAlertModal={this.toggleAlert_loginFail}
          showAlertModal={showAlert_loginFail}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loggingIn: state.authentication.loggingIn,
});

export default connect(mapStateToProps)(LoginModal);
